import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

    transform(value: any, withSuffix = true, space = ''): any {
        if (value === undefined || value === null) {
            value = 0;
        }
        value = +value;
        if (value >= 2 * 31536000) { // year
            const frac = Math.round((value % 31536000) / 31536000 * 10);
            return (Math.trunc(value / 31536000) + (frac == 10 ? 1 : 0))
                + (frac > 0 && frac < 10 ? '.' + frac : '')
                + (withSuffix ? space + 'г' : '');
        }
        else if (value >= 2 * 2592000) { // month
            const frac = Math.round((value % 2592000) / 2592000 * 10);
            return (Math.trunc(value / 2592000) + (frac == 10 ? 1 : 0))
                + (frac > 0 && frac < 10 ? '.' + frac : '')
                + (withSuffix ? space + 'мес' : '');
        }
        else if (value >= 3 * 86400) { // day
            const frac = Math.round((value % 86400) / 86400 * 10);
            return (Math.trunc(value / 86400) + (frac == 10 ? 1 : 0))
                + (frac > 0 && frac < 10 ? '.' + frac : '')
                + (withSuffix ? space + 'д' : '');
        }
        else if (value >= 1.5 * 3600) { // hour
            const frac = Math.round((value % 3600) / 3600 * 10);
            return (Math.trunc(value / 3600) + (frac == 10 ? 1 : 0))
                + (frac > 0 && frac < 10 ? '.' + frac : '')
                + (withSuffix ? space + 'ч' : '');
        }
        else {
            return Math.trunc(value / 60) + (withSuffix ? space + 'м' : '');
        }
    }

}

@NgModule({
    imports: [CommonModule],
    declarations: [DurationPipe],
    exports: [DurationPipe]
})
export class DurationPipeModule { }

